import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const CollectionsLazy = loadable(() => import(/* webpackChunkName: "Collections" */ './Collections'));

export const CollectionsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <CollectionsLazy />
    </DelayedSuspense>
);
